<template>
    <rkm-modal
        ref="modal"
        title="Mensagens e respostas"
        large
    >
        <rkm-form
            ref="Form"
            show-legend
        >
                <rkm-row v-if="model.statusId !== enums.statusTipo.CANCELADO && model.statusId !== enums.statusTipo.FINALIZADO">
                    <rkm-col>
                        <rkm-form-textarea
                            :disabled="!isLastMessageResponded()"
                            :label="novoComentarioLabel()"
                            :validations="validations.mensagemAtual"
                            class="mb-2"
                            v-model="model.comentarioAtual"
                        />
                    </rkm-col>
                </rkm-row>

            <div v-if="model.mensagensResposta && model.mensagensResposta.length">
                <div v-for="(mensagem, index) in model.mensagensResposta" :key="index">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                v-if="mensagem.resposta"
                                :readonly="mensagem.resposta ? true : false"
                                :value="mensagem.resposta ? mensagem.resposta.respostaMensagem : ''"
                                class="mb-2"
                                label="Resposta"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col class="d-flex justify-content-end">
                            <small v-if="mensagem.resposta">
                                <em>Data: {{ mensagem.resposta.respostaData }}</em>&nbsp;&nbsp;
                                <em>Hora: {{ mensagem.resposta.respostaHora }}</em>&nbsp;&nbsp;
                                <em>Usuário: {{ mensagem.resposta.respostaUsuario }}</em>
                            </small>
                        </rkm-col>
                    </rkm-row>
                    <hr v-if="mensagem.mensagem" class="mt-1 mb-1">

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                :readonly="true"
                                class="mb-2"
                                label="Mensagem"
                                v-model="mensagem.mensagem.mensagemConteudo"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col class="d-flex justify-content-end">
                            <small>
                                <em>Data: {{ mensagem.mensagem.mensagemData }}</em>&nbsp;&nbsp;
                                <em>Hora: {{ mensagem.mensagem.mensagemHora }}</em>&nbsp;&nbsp;
                                <em>Usuário: {{ mensagem.mensagem.mensagemUsuario }}</em>
                            </small>
                        </rkm-col>
                    </rkm-row>
                    <hr class="mt-1 mb-1">
                </div>
            </div>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">Cancelar</rkm-button>
            <rkm-button @click="save" color="primary" type="submit">Salvar</rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Mixin.
import { repository, stringCase } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
     computed: {
        validations() {
            return {
                mensagemAtual: {
                    max: 500,
                    required: true,
                }
            }
        },
    },
    created() {

        this.repositories = {
            gerenciamento: this.getConectaSusRepository('manutencao.gerenciamento'),
        }
    },
    data: () => ({
        model: {
            id: null,
            mensagensResposta: [],
            comentarioAtual: null,
            statusId: null
        },
        enums: { statusTipo }
    }),
    methods: {

        open(item) {

            this.model.id = item.id
            this.model.statusId = item.statusId
            this.model.mensagensResposta = item.mensagensResposta || [];
            this.model.comentarioAtual = null

            this.$refs.modal.show()
        },
        save() {
            if (!this.model.comentarioAtual) {
                return;
            }

            this.$refs.Form.validate()
                .then((valid) => {
                    if (valid) {

                        const request = {
                            acao: 'mensagem',
                            comentarioAtual: this.model.comentarioAtual,
                        }

                        this.repositories.gerenciamento.update(
                            this.model.id,
                            this.prepareData(request)
                        )
                            .then(() => {
                                this.$refs.modal.hide()
                                this.$emit('refresh')
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })

        },
        prepareData(request) {

            return this.camelObjectKeysToSnakeRecursive(request);
        },
        isLastMessageResponded() {
            if (!this.model.mensagensResposta || this.model.mensagensResposta.length === 0) {
                return true;
            }
            const lastMessage = this.model.mensagensResposta[0];
            return lastMessage.resposta;
        },
        novoComentarioLabel() {
            return this.isLastMessageResponded()
                ? 'Novo comentário'
                : 'Novo comentário (aguarde a resposta da última mensagem enviada)';
        }
    },
    mixins: [ repository, stringCase ],
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>